import React, { useState } from "react";
import BasedModal, { IProps } from "components/BaseModalComponents/BasedModal";
import { Container, ModalBody, Input } from "./styles";
import { useDispatch } from "react-redux";
import { createGroup } from "store/reducers/GroupsSlice";
import ModalFooter from "../BaseModalComponents/Footer/ModalFooter";
import Error from "utils/Notifications/Error";

function NewGroupModal({ isOpen, onRequestClose }: IProps) {
    const dispatch = useDispatch();
    const [groupName, setGroupName] = useState("");

    const onChange = (e: any) => {
        setGroupName(e.target.value);
    };

    const onApplyClick = (e: any) => {
        if (!groupName.trim()) {
            Error("Название группы не может быть пустым");
            return;
        }
        dispatch(createGroup({ name: groupName, type: "create" }));
        if (onRequestClose) {
            onRequestClose(e);
        }
    };

    return (
        <BasedModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <Container>
                <ModalBody>
                    <div>Введите название новой группы</div>
                    <Input
                        placeholder="Имя"
                        value={groupName}
                        onChange={onChange}
                    />
                </ModalBody>
                <ModalFooter
                    style={{
                        padding: "7px 11px 10px 15px",
                    }}
                    applyText="Применить"
                    onApplyClick={onApplyClick}
                    cancelText="Отменить"
                    onCancelClick={onRequestClose}
                />
            </Container>
        </BasedModal>
    );
}

export default NewGroupModal;
